import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { theme } from '../theme';
import { FeedbackModal } from './FeedbackModal';

interface FeedbackSidebarButtonProps {
  onClose?: () => void;
}

export const FeedbackSidebarButton: React.FC<FeedbackSidebarButtonProps> = ({ onClose }) => {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getPageName = (pathname: string): string => {
    const pathMap: { [key: string]: string } = {
      '/home': 'Página Principal',
      '/create-match': 'Crear Partido',
      '/matches': 'Mis Partidos',
      '/profile': 'Mi Perfil',
      '/friends': 'Amigos',
      '/reviews': 'Reviews',
      '/join': 'Unirse a Partido',
      '/match': 'Ver Partido',
      '/leave': 'Abandonar Partido',
      '/auth': 'Autenticación',
      '/auth-callback': 'Callback de Autenticación',
      '/auth/callback': 'Callback de Autenticación',
      '/auth/failure': 'Error de Autenticación'
    };

    // Para rutas dinámicas como /match/:id, /public-profile/:id, etc.
    if (pathname.startsWith('/match/')) return 'Ver Partido';
    if (pathname.startsWith('/public-profile/')) return 'Perfil Público';
    if (pathname.startsWith('/join/')) return 'Unirse a Partido';
    if (pathname.startsWith('/leave/')) return 'Abandonar Partido';

    return pathMap[pathname] || `Página: ${pathname}`;
  };

  const handleClick = () => {
    setIsModalOpen(true);
    onClose?.(); // Cerrar el sidebar en mobile
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          width: '100%',
          padding: '12px 16px',
          backgroundColor: 'transparent',
          border: 'none',
          color: theme.colors.text,
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          borderRadius: '8px',
          transition: 'all 0.2s ease',
          fontFamily: theme.fonts.body,
          textAlign: 'left'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255, 107, 53, 0.1)';
          e.currentTarget.style.color = '#FF6B35';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = theme.colors.text;
        }}
        title="Reportar un error o sugerir mejora"
      >
        <span style={{ fontSize: '16px' }}>⚠️</span>
        <span>Reportar Error</span>
      </button>

      <FeedbackModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        currentPage={getPageName(location.pathname)}
        currentUrl={window.location.href}
      />
    </>
  );
};
